<template>
    <CustomizerStepShell
        :builder-content-missing="builderContentMissing"
        :can-show-content="canShowContent"
        :model="model"
        :content="content"
        :api-key="apiKey"
        :custom-components="getRegisteredComponents()"
    />
</template>

<script>
import { captureCustomizerException } from "../../utils/sentry";
import cartMixin from "../../mixins/cartMixin";
import builderIoMixin from "../../mixins/builderIoMixin";
import stepNavigationMixin from "../../mixins/stepNavigationMixin";
import shareMixin from "../../mixins/shareMixin";
import CustomizerStepShell from "./CustomizerStepShell.vue";

export default {
    name: "StepThree",
    components: {
        CustomizerStepShell,
    },
    mixins: [cartMixin, builderIoMixin, stepNavigationMixin, shareMixin],
    mounted() {
        this.initializeBuilderContent("StepThree")
            .then(() => {
                if (!this.isBuilderIoMode()) {
                    const didRedirect = this.validateAndRedirectToPreviousSteps(
                        this.pageSettings, 
                        "StepThree"
                    );
                    if (didRedirect) return;
                }
            })
            .catch(error => {
                if (process.env.VUE_APP_DEV_MODE === "true") {
                    console.error("Error initializing StepThree", {
                        code: error?.code || "unknown",
                    });
                }
                captureCustomizerException(error, {
                    tags: { component: "StepThree", failure_reason: "step_initialization_failed" },
                });
            });
    },
};
</script>
